<template>
  <div>
    <el-card shadow="never" class="card" header="BASIC INFORMATION">
      <customize-form-info
        ref="basicForm"
        :infoData="basicData"
        @handleDownload="handleDownload"
      ></customize-form-info>
    </el-card>
    <el-card shadow="never" class="card" header="COMMENTS">
      <customize-form ref="commentsForm" :schema="commentsModel">
        <template v-slot:uploadSlot>
          <el-upload
            ref="upload"
            :action="uploadUrl"
            :headers="{ Authorization: $store.state.token }"
            :auto-upload="true"
            :show-file-list="true"
            :on-change="handleChange"
            :file-list="fileList"
            :on-success="uploadSuccess"
            style="margin-top: 20px"
          >
            <customize-button class="upload">Add Attachment</customize-button>
          </el-upload>
        </template>
      </customize-form>
    </el-card>
    <el-card shadow="never" class="card2">
      <el-form :label-position="labelPosition" :model="approveForm">
        <el-form-item label="Select Approver">
          <el-select
            v-model="approveForm.approver"
            filterable
            placeholder="select"
            style="width: 250px"
          >
            <el-option
              v-for="item in nameList"
              :key="`${item.username}_${item.roleId}`"
              :label="`${item.username}`"
              :value="`${item.username}_${item.roleId}`"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
    <div class="btnArea">
      <customize-button style="margin-right: 20px" @click="handleCancel">
        Cancel
      </customize-button>
      <customize-button type="primary" @click="handleContinue">
        Submit
      </customize-button>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import { ERR_OK } from '@/utils/request'
import { vagueSearch, downloadFile, handleDetailSubmit } from './api'
import mixins from '../mixins/mixins'

export default {
  name: 'detail',
  mixins: [mixins],
  data() {
    const basicData = []
    Object.keys(this.$route.params).forEach(key => {
      if (key === 'total' || key === 'typeStr' || key === 'fileName') {
        basicData.push({
          key: mixins.methods.transLabelToName(key),
          value: this.$route.params[key],
        })
      }
    })
    const commentsModel = [
      {
        key: 'remark',
        label: '',
        type: 'textarea',
      },
    ]
    const approveModel = [
      {
        key: 'approver',
        label: 'Select Approver',
        type: '',
      },
    ]
    return {
      uploadUrl: `${config.baseApi}/workflow-api/credit-apply/attachment/upload`,
      basicData,
      commentsModel,
      fileList: [],
      approveModel,
      //  approve name form
      approveForm: {
        approver: '',
      },
      labelPosition: 'top',
      nameList: [],
    }
  },
  mounted() {
    this.getNameList()
  },
  methods: {
    handleChange(file, fileList) {
      if (!file.response) {
        this.fileList.splice(0, 1, file)
      }
      this.fileList = fileList
    },
    uploadSuccess({ code, msg }) {
      if (code === ERR_OK) {
        this.$message.success('success')
      } else {
        this.$message.error(msg)
        this.fileList.pop()
      }
    },
    async getNameList() {
      try {
        this.nameList = await vagueSearch()
      } catch (err) {
        console.error(err)
      }
    },
    handleCancel() {
      this.$router.go(-1)
    },
    async handleDownload() {
      try {
        await downloadFile(this.$route.query.id)
        this.$message.success('success')
      } catch (err) {
        console.error(err)
      }
    },
    async handleContinue() {
      try {
        const _index = this.approveForm.approver.indexOf('_')
        const params = {
          id: this.$route.query.id,
          approvePersons: [
            {
              username: this.approveForm.approver.slice(0, _index),
            },
          ],
          attachmentIds: this.fileList.map(file => file.response.data),
          remark: this.$refs.commentsForm.getFormData().remark,
        }
        await handleDetailSubmit(params)
        this.$message.success('success')
        this.$router.go(-1)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>

<style scoped lang="less">
.card {
  width: 100%;
  margin-bottom: 24px;
}
.card2 {
  width: 100%;
  margin-top: 24px;
}
.btnArea {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
</style>
